import { isStreamIQ } from '@/shared/lib'

export async function getGetSeriesContentModule() {
    if (isStreamIQ()) {
        try {
            const module =
                await require('@/clients/streamiq/features/Series/SeriesContent')
            return module.SeriesContent
        } catch (error) {
            console.warn(
                'SeriesContent module is missing. StreamIQ-specific features are disabled.',
                error
            )
            return null
        }
    }
}
